module.exports = __webpack_public_path__ + "img/informe-de-reporte-de-facturas.96e49eaf.svg";